module.exports = __webpack_public_path__ + "img/3.507af7eb.png";